import axios from '@axios'

export default {
  getMembers(page, field) {
    return axios.post(`admin/users/members?page=${page}`, field)
  },

  getMemberFilterOptions() {
    return axios.get('admin/users/members/filter-options')
  },

  exportMembers(field, format = 'csv_comma', exportColumns = []) {
    return axios.post('admin/users/members/export', { ...field, format, export_columns: exportColumns }, { responseType: 'blob' })
  },

  searchMembersForFilter(keyword, selectedIds = [], paginate = 30) {
    const payload = { paginate }

    if (keyword && String(keyword).trim()) {
      payload.keyword = String(keyword).trim()
    } else if (selectedIds.length) {
      payload.users_ids = selectedIds
    } else {
      return Promise.resolve({ data: { result: { data: [] } } })
    }

    return axios.post('admin/users/members', payload)
  },

  searchCityForFilter(city) {
    return axios.post('platform/roads/cities/search/map', { city })
  },

  getAdmins(page, field) {
    return axios.post(`admin/users/admins?page=${page}`, field)
  },

  getPartners(page, field) {
    return axios.post(`admin/partners/list?page=${page}`, field)
  },

  update(user) {
    return axios.put(`admin/users/${user.id}`, user)
  },
  updatePartner(partner) {
    return axios.put(`admin/partners/${partner.id}`, partner)
  },

  getUser(id) {
    return axios.get(`admin/users/${id}`)
  },
  getPartner(id) {
    return axios.get(`admin/partners/${id}`)
  },

  validateUserLicense(id,doc) {
    return axios.post(`admin/users/validate/${id}/license`, {doc: doc})
  },

  rejectUserLicense(id, field, doc) {
    return axios.put(`admin/users/reject/${id}/license`, field)
  },

  lockUser(id, field) {
    return axios.put(`admin/users/${id}/lock`, field)
  },

  getStats() {
    return axios.get('admin/users/stats/get')
  },

  addAdmin(user) {
    return axios.post('admin/users', user)
  },
  addPartner(user) {
    return axios.post('admin/partners', user)
  },

  activateForSubmitLicense(user) {
    return axios.get(`admin/users/activate/${user.id}/license/notification`, user)
  },
}
